import type { ReactNode } from 'react';
import { Badge } from '@paige/ui';
import './admin.css';

/**
 * The mark beside one of Ademero's own test companies (`tenants.flags.testCompany`), wherever a company is
 * named in the admin area: the same word on every page, so nobody takes a load test for a customer.
 */
export function TestMark(): ReactNode {
  return (
    <Badge
      tone="staff"
      className="ad-test-mark"
      title="One of Ademero's own test companies; hidden from every list and total while Hide test companies is on"
    >
      Test
    </Badge>
  );
}

/** A company's name with the mark after it when it is one of ours. */
export function CompanyName({ name, test }: { name: ReactNode; test: boolean }): ReactNode {
  return test ? (
    <span className="ad-company-name">
      {name} <TestMark />
    </span>
  ) : (
    <>{name}</>
  );
}
